import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouterLinkActive } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { DndModule } from 'ng2-dnd';

import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { HomeComponent } from './home/home.component';
import { BaseComponent } from './base/base.component';


import { CanvasComponent } from './base/components/canvas/canvas.component';
import { ValuePropositionComponent } from './base/components/canvas/components/value-proposition/value-proposition.component';
import { PropositionService } from './base/components/canvas/components/value-proposition/propositions/proposition.service';
import { SustainabilityGoalsComponent } from './base/components/canvas/components/sustainability-goals/sustainability-goals.component';
import { GoalsService } from './base/components/canvas/components/sustainability-goals/goals/goals.service';
import { BusinessAreasComponent } from './base/components/canvas/components/business-areas/business-areas.component';
import { ProductsService } from './base/components/canvas/components/business-areas/products/products.service';
import { SustainabilityRatingComponent } from './base/components/canvas/components/sustainability-rating/sustainability-rating.component';
import { TraditionalRatingService } from './base/components/canvas/components/sustainability-rating/rating/traditional-rating.service';
import { TrendsComponent } from './base/components/canvas/components/trends/trends.component';
import { TrendsService } from './base/components/canvas/components/trends/trends/trends.service';
import { TransitionMatrixComponent } from './base/components/canvas/components/transition-matrix/transition-matrix.component';
import { ItemsService } from './base/components/canvas/components/transition-matrix/items/items.service';
import { InnovationFilterComponent } from './base/components/canvas/components/innovation-filter/innovation-filter.component';

import { KeynoteComponent } from './base/components/keynote/keynote.component';
import { TodayComponent } from './base/components/keynote/components/today/today.component';
import { ServiceSocietyComponent } from './base/components/keynote/components/today/components/service-society/service-society.component';
import { ImpactSocietyComponent } from './base/components/keynote/components/today/components/impact-society/impact-society.component';
import { CurrentContextComponent } from './base/components/keynote/components/today/components/current-context/current-context.component';
import { TomorrowComponent } from './base/components/keynote/components/tomorrow/tomorrow.component';
// tslint:disable-next-line:max-line-length
import { CapacityScanningComponent } from './base/components/keynote/components/tomorrow/components/capacity-scanning/capacity-scanning.component';
import { TrendScanningComponent } from './base/components/keynote/components/tomorrow/components/trend-scanning/trend-scanning.component';
import { TransitionComponent } from './base/components/keynote/components/transition/transition.component';
import { KeynoteMatrixComponent } from './base/components/keynote/components/transition/components/keynote-matrix/keynote-matrix.component';
import { NextComponent } from './base/components/keynote/components/next/next.component';
// tslint:disable-next-line:max-line-length
import { ImplementationStrategyComponent } from './base/components/keynote/components/next/components/implementation-strategy/implementation-strategy.component';
import { TasksService } from './base/components/keynote/components/next/components/implementation-strategy/tasks/tasks.service';

import { KanbanComponent } from './base/components/kanban/kanban.component';
import { MondayTasksComponent } from './base/components/kanban/components/monday-tasks/monday-tasks.component';
import { MondayTasksService } from './base/components/kanban/components/monday-tasks/monday-tasks/monday-tasks.service';
import { LinkStrategiesComponent } from './base/components/kanban/components/link-strategies/link-strategies.component';
import { StrategyOverviewComponent } from './base/components/kanban/components/strategy-overview/strategy-overview.component';
import { TimeplansService } from './base/components/kanban/components/strategy-overview/timeplans/timeplans.service';
import { IncentivesService } from './base/components/kanban/components/strategy-overview/incentives/incentives.service';
import { TeamsService } from './base/components/kanban/components/strategy-overview/teams/teams.service';

import { CapitalizePipe } from './pipes/capitalize.pipe';
import { ReversePipe } from './pipes/reverse.pipe';

const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'start', component: BaseComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    CanvasComponent,
    KanbanComponent,
    KeynoteComponent,
    HomeComponent,
    ValuePropositionComponent,
    SustainabilityGoalsComponent,
    BusinessAreasComponent,
    SustainabilityRatingComponent,
    TrendsComponent,
    TransitionMatrixComponent,
    BaseComponent,
    TodayComponent,
    ServiceSocietyComponent,
    ImpactSocietyComponent,
    CurrentContextComponent,
    TomorrowComponent,
    CapacityScanningComponent,
    TrendScanningComponent,
    KeynoteMatrixComponent,
    TransitionComponent,
    NextComponent,
    ImplementationStrategyComponent,
    CapitalizePipe,
    InnovationFilterComponent,
    ReversePipe,
    MondayTasksComponent,
    LinkStrategiesComponent,
    StrategyOverviewComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true } // <-- debugging purposes only
    ),
    RouterModule,
    DndModule.forRoot(),
    FormsModule
  ],
  providers: [
    PropositionService,
    GoalsService,
    ProductsService,
    TraditionalRatingService,
    TrendsService,
    ItemsService,
    TasksService,
    MondayTasksService,
    TimeplansService,
    IncentivesService,
    TeamsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/app.module.ts